import React, { Component } from 'react';

class InputNumeric extends Component {
    render(){
        return (<input type="number" min={this.props.min} max={this.props.max} step={this.props.step} data-which={this.props.which} data-type="number" value={this.props.value} onChange={this.props.change} disabled={this.props.disabled} />);
    }
}
export default InputNumeric;
